<template class="pa-0">
 <v-card>
    <v-card-title>
       <span> Ingreso combustible</span>

        <v-divider  class="mx-4" inset vertical></v-divider>



          <v-spacer></v-spacer>

        
            

              <vue-excel-xlsx v-show="data_excel.length >0" class="ml-4"
                                    :data="data_excel"
                                    :columns="column_excel"
                                    :file-name="'combustible'"
                                    :sheet-name="'hoja1'"
                                    :file-type="'xlsx'">
                                    <v-btn color="info">
                                        <v-icon dark>get_app</v-icon>
                                    </v-btn>
                                
                        </vue-excel-xlsx>


            <v-flex class="mx-5">
                <v-btn dark color="info" @click="dialog=true">
                  <v-icon>add</v-icon>
                </v-btn>
          </v-flex>


         <v-flex>
                <v-btn dark color="success" @click="dialogInicio=true">
                  <v-icon>date_range</v-icon>
                </v-btn>
          </v-flex>

            

      <v-text-field
       class="mr-4"
        v-model="search"
        append-icon="search"
        label="buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>



  <v-data-table
    :headers="headers"
    :items="ArrayIngresos"
    :search="search"
    sort-by="fecha"
    class="elevation-1 pa-0"
  >
 
      
    <template v-slot:[`item.actions`]="{ item }">

      <v-icon small @click="deleteItem(item)">delete
        
      </v-icon>

       <v-icon small @click="editItem(item)">edit</v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>

     <template v-slot:[`item.fecha`]="{ item }"> 
       <span>{{ConvertirFecha(item.fecha)}} </span>
     </template>


     <template v-slot:[`item.cantidad`]="{ item }">
          <span>{{ item.cantidad}} Gln</span>
     </template>

     <template v-slot:[`item.costo`]="{ item }">
         <span>{{ item.costo}}</span>
     </template>

     <template v-slot:[`body.append`]>
        <tr>
          <td>
            <span><!--mdicon name="fuel" /--><strong>  Total Gln</strong> </span>
             <v-chip  class="ma-2" color="pink"  text-color="white">{{ total_gl}}
            </v-chip>
          </td>

          <td>
             <span><!--mdicon name="cash" /--><strong> totales $</strong></span>
            <v-chip  class="ma-2" color="green"  text-color="white">{{ total_dls }}
            </v-chip>

          </td>
        </tr>
      </template>



        <template v-slot:[`item.comentario`]="{ item }">
         <span class="text-caption">{{ item.comentario}}</span>
     </template>

       <template v-slot:[`item.observacion`]="{ item }">
         <span class="text-caption">{{ item.observacion}}</span>
     </template>


  </v-data-table>


       <v-dialog v-model="dialog" max-width="700px">
        
          <v-card>
         
        <v-toolbar dark color="indigo">
              <v-toolbar-title>
                 <span class="headline">{{ formTitle }}</span>
              </v-toolbar-title>
                 <v-spacer></v-spacer>
                 <v-icon @click="dialog=false" dark>close</v-icon>

            </v-toolbar>



            <v-card-text>
              <v-container>

                 <v-row>

                <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                            v-model="editedItem.id_vehiculo"
                            :items="UnidadesArray"
                            prepend-icon="time_to_leave"
                            label="Vehiculo"
                            :rules="[rules.required]"
                            :error-messages="errorMessages"
                          
                        ></v-autocomplete>
                  </v-col>



               
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                    prepend-icon="local_gas_station"
                      v-model="editedItem.cantidad"
                      label="Cantidad Gln"
                    ></v-text-field>
                  </v-col>


                  <v-col cols="12" sm="4"  md="4">
                    <v-text-field
                      prepend-icon="payments"
                      v-model="editedItem.costo"
                      label="Costo"
                    ></v-text-field>
                  </v-col>


                   <v-col cols="12" sm="4" md="4">
                   

                     <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="editedItem.fecha"
                            label="Fecha puesto comb"
                            prepend-icon="today"
                            v-bind="attrs"
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editedItem.fecha"
                            no-title
                            @input="menu1 = false"
                        ></v-date-picker>
                        </v-menu>

                  </v-col>


                  <v-col cols="12" sm="4" md="4">
                   <v-text-field
                    prepend-icon="local_gas_station"
                      v-model="editedItem.estacion"
                      label="Estacion"
                    ></v-text-field>
                  </v-col>


                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      prepend-icon="mode_comment"
                      v-model="editedItem.comentario"
                      label="Comentario"
                    ></v-text-field>
                  </v-col>



                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn  color="blue darken-1" text @click="close">
                Cancel
              </v-btn>
              <v-btn color="primary" @click="save">
                Guardar
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">seguro deseas borrar ingreso?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
              <v-btn color="primary" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogInicio" persistent max-width="280">
          <v-card>
            <v-toolbar flat color="indigo" class="text-center">
            <v-toolbar-title class="white--text  text-center"><strong>Historial por fechas</strong></v-toolbar-title>
          </v-toolbar>

            <v-card-text>

              <v-flex>

                        <v-menu
                          ref="menuFecha1"
                          v-model="menuFecha1"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                      
                          offset-y
                          min-width="290px"
                        >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="fecha_inicio"
                                  label="Fecha inicio"
                                  prepend-icon="event"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="fecha_inicio" locale="es"
                              no-title  @input="menuFecha1 = false" scrollable>
                              </v-date-picker>
                        </v-menu>
                  </v-flex>

              <v-flex>
                    <v-menu
                      ref="menuFecha2"
                      v-model="menuFecha2"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                  
                      offset-y
                      min-width="290px"
                    >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="fecha_fin"
                              label="Fecha fin"
                              prepend-icon="event"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="fecha_fin" locale="es"
                          no-title  @input="menuFecha2 = false" scrollable>
                          </v-date-picker>
                    </v-menu>

                  </v-flex>

              
                    <v-flex justify-center d-flex>
                      
                          <v-btn color="success" dark @click="listar()" style="margin-right:10px;">Generar</v-btn>
                        <v-btn  @click="dialogInicio=false" style="margin-right:10px;">Cancelar</v-btn>

                  </v-flex>
      
            </v-card-text>
          
          </v-card>
      </v-dialog>



 </v-card>

</template>

<script>


import axios from 'axios';

import { mapMutations, mapState } from "vuex";



  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
                    
      

        { text: 'Vehiculo', value: 'id_vehiculo.nombre' },
        { text: 'Placa', value: 'id_vehiculo.placa' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Estacion', value: 'estacion' },
        { text: 'Cantidad', value: 'cantidad' },
        { text: 'Costo', value: 'costo' },
        { text: 'Estacion', value: 'estacion'},
        { text: 'Comentario', value: 'comentario' },
        { text: 'Detalle', value: 'observacion' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        cantidad:0,
        costo:0,
        comentario:'',
        fecha:new Date().toISOString().substr(0, 10),
        id_vehiculo:'',
        id_comb_pais:'',
        estado:1,
        estacion:'',
      
      },
      defaultItem: {
        cantidad:0,
        costo:0,
        comentario:'',
        fecha:new Date().toISOString().substr(0, 10),
        id_vehiculo:'',
        id_comb_pais:'',
        estado:1,
        observacion:'',
        estacion:'',
     
      },

       ArrayIngresos:[],
       UnidadesArray:[],

       menu: false,
       dialogInicio:false,

        menuFecha1:false,
        fecha_inicio:new Date().toISOString().substr(0, 10),
        menuFecha2:false,
        fecha_fin:new Date().toISOString().substr(0, 10),
        date: new Date().toISOString().substr(0, 10),

          search:'',
          data_excel:[],

          column_excel:[ 
                    {label: "Vehiculo",  field: "vehiculo"},
                    {label: "Placa", field: "placa"},
                    {label: "Flota", field: "flota"},

                    {label: "Cantidad",  field: "cantidad"},
                    {label: "Costo", field: "costo"},
                    {label: "Fecha", field: "fecha"},
                    {label: "Comentario", field: "comentario"},
                    {label: "Observacion",  field: "observacion"},
                    {label: "Estacion", field:"estacion"}
                    ],

         menu1: false,

        errorMessages:'',
       rules: {
          numerico:(value)=>value > 0 || "valor incorrecto",
          min3Chars: (value) => value.length >= 3 || "Min. 3 characters",
          required: (value) => !!value || "campo Requerido.",
          email: (value) => {
                              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                              return pattern.test(value) || "Invalid e-mail.";
                           },
       
       },

       total_gl:0,
       total_dls:0,

    
       nombre_archivo:'',
       status_procesado:false,
       finalizadaCarga:false,

    
        insertados:0,

    



    }),

    computed: {

          ...mapState(['usuario', 'token']),

      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo ingreso' : 'Edicion ingreso'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {

         ...mapMutations(['mostrarLoading','ocultarLoading']),

      initialize () {

       
        this.ArrayIngresos = [];
        this.listarVehiculos();
        this.listar();
      },

          

       listar(){

                this.ArrayIngresos=[];
                this.total_gl=0;
                this.total_dls=0;

              this.mostrarLoading({titulo:'Accediendo a datos'});
              let config={headers:{token:this.token}};
              let me=this;
              axios.post('combustibles-reporte',
                      { 

                      'desde':this.fecha_inicio,
                      'hasta':this.fecha_fin,
                      'id_empresa':this.usuario.id_usr_empresa._id
                       },
                  config
                  ).then(function(response){
                      console.log(response);
                      me.ArrayIngresos=response.data;


                     me.ArrayIngresos.map(function(x){

                         me.data_excel.push({ 
                              'vehiculo':x.id_vehiculo.nombre,
                              'placa':x.id_vehiculo.placa,
                              'flota':x.id_vehiculo.flota,
                              'cantidad':x.cantidad,
                              'Costo':x.costo,
                              'fecha':me.ConvertirFecha(x.fecha),
                              'comentario':x.comentario,
                              'observacion':x.observacion,
                              'estacion':x.estacion
                              }); 

                              
                              me.total_gl=parseFloat(x.cantidad)+me.total_gl;
                              me.total_dls=parseFloat(x.costo)+me.total_dls;


                       });


                         me.total_gl=parseFloat(me.total_gl).toFixed(2);
                         me.total_dls=parseFloat(me.total_dls).toFixed(2);


                      me.ocultarLoading();
                     
                      me.dialogInicio=false;
                  }).catch(function(error){ console.log(error); });

          },

      listarVehiculos(){

                    this.ArrayVehiculos=[];
                 
                 

                      this.mostrarLoading({titulo:'Accediendo a datos'});
                      let config={headers:{token:this.token}};
                      let me=this;
                    axios.get(`vehiculos/${this.usuario.id_usr_empresa._id}`,
                        config
                        ).then(function(response){
                            console.log(response);
                            me.ArrayVehiculos=response.data;

                            me.ArrayVehiculos.map(function(x){
                                        me.UnidadesArray.push({'text':x.nombre, 'value':x._id});
                            });

                          me.ocultarLoading();
                        }).catch(function(error){ console.log(error); });

       },






      editItem (item) {
        this.editedIndex = this.ArrayIngresos.indexOf(item)
        this.editedItem = Object.assign({}, item);
        this.editedItem.fecha=new Date(item.fecha).toISOString().substr(0, 10);

        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.ArrayIngresos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      
                  let config={headers:{token:this.token}};
                    this.mostrarLoading({titulo:'actualizando'});
                   let id=this.editedItem._id;
                    let me=this;

                    axios.put(`combustibles/${id}`,
                      { 
                        'observacion':'baja por:'+this.usuario.nombre_usuario+'a las:'+me.getDate(new Date()),
                        'estado':0
                       },
                       config
                        ).then(response=>{
                      
                         console.log(response);
                        
                         this.listar();
                         this.ocultarLoading();
                         this.closeDelete()

                  }).catch(e=>{
                        console.log(e)
                  });


      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {

          //Object.assign(this.ArrayIngresos[this.editedIndex], this.editedItem)
        
                   let config={headers:{token:this.token}};
                    this.mostrarLoading({titulo:'actualizando'});
                    let id=this.editedItem._id;
                    let me=this;

                    axios.put(`combustibles/${id}`,
                      { 

                        'cantidad':this.editedItem.cantidad,
                        'costo':this.editedItem.costo,
                        'comentario':this.editedItem.comentario,
                        'fecha':new Date(this.editedItem.fecha+"T00:00:00.000-06:00"),
                        'id_vehiculo':this.editedItem.id_vehiculo,
                        'id_empresa':this.usuario.id_usr_empresa._id,
                        'estacion':this.editedItem.estacion,
                        'observacion':'Actualizado por:'+this.usuario.nombre_usuario+'a las:'+me.getDate(new Date()),
                        'estado':this.editedItem.estado
                       },
                       config

                        ).then(response=>{
                      
                         console.log(response);
                        
                         this.listar();
                         this.ocultarLoading();
                         this.close()

                  }).catch(e=>{
                        console.log(e)
                  });




        } else {
         // this.ArrayIngresos.push(this.editedItem)
            //ingreso de nuevos registros

         


                if((this.editedItem.cantidad!='')&&(this.editedItem.cantidad!=0)&&(this.editedItem.costo!='')
                    &&(this.editedItem.costo!=0)&&(this.editedItem.comentario!='')&&(this.editedItem.id_vehiculo!='')){


                   let config={headers:{token:this.token}};
                   this.mostrarLoading({titulo:'actualizando'});

                   let me=this;
                   
                    axios.post('nuevo-combustible',
                      {  
                        'cantidad':this.editedItem.cantidad,
                        'costo':this.editedItem.costo,
                        'comentario':this.editedItem.comentario,
                        'fecha':new Date(this.editedItem.fecha+"T00:00:00.000-06:00"),
                        'id_vehiculo':this.editedItem.id_vehiculo,
                        'id_empresa':this.usuario.id_usr_empresa._id,
                        'estacion':this.editedItem.estacion,
                        'estado':1,
                        'observacion':'ingresado por:'+this.usuario.nombre_usuario+',a las:'+me.getDate(new Date())
                       },
                       config

                        ).then(response=>{
                      
                         console.log(response);
                        
                         this.listar();
                         this.ocultarLoading();
                         this.close()

                  }).catch(e=>{
                        console.log(e)
                  });

             }else{
                 alert('faltan campos');
             }






        }
        
      },


      getDate(evaluar) {
      let date = new Date(evaluar),
      year = date.getFullYear(),
      month = (date.getMonth() + 1).toString(),
      formatedMonth = (month.length === 1) ? ("0" + month) : month,
      day = date.getDate().toString(),
      formatedDay = (day.length === 1) ? ("0" + day) : day,
      hour = date.getHours().toString(),
      formatedHour = (hour.length === 1) ? ("0" + hour) : hour,
      minute = date.getMinutes().toString(),
      formatedMinute = (minute.length === 1) ? ("0" + minute) : minute,
      second = date.getSeconds().toString(),
      formatedSecond = (second.length === 1) ? ("0" + second) : second;
    return formatedDay + "-" + formatedMonth + "-" + year + " " + formatedHour + ':' + formatedMinute + ':' + formatedSecond;
    },


     ConvertirFecha(fecha_parametro){
          let texto=new Date(fecha_parametro).toLocaleDateString();
          return(texto);

      },

      


    },
  }
</script>